import Debouncer from '../lib/Debouncer';

const privacyPolicyForm = () => {
	if (document.querySelector('.hasPrivacyPolicyForm')) {
		const setBodyMarginBottom = new Debouncer(() => {
			const privacyPolicyFormHeight = document.querySelector('.privacyPolicyForm').getBoundingClientRect().height;
			document.body.style.marginBottom = `${privacyPolicyFormHeight}px`;
		});
		window.addEventListener('resize', setBodyMarginBottom.run);
		setBodyMarginBottom.runNow();
	}
}

export default privacyPolicyForm;